export default "__VITE_ASSET__VNnqdlfC__"